import { CloseRounded } from '@mui/icons-material';
import { Avatar, Box, Button, TextField, Tooltip } from '@mui/material';

import { Guest } from '../../services';
import { stringAvatar } from '../../utils/avatarGenerator';

import { CardUsers, Header, Title } from './styles';

interface DrawerConfirmRequestSignaturesProps {
  setOpenDrawerConfirmConfigureSignature: (type: boolean) => void;
  users: Guest[];
  setStepDrawer: (type: string) => void;
}

export const DrawerConfirmRequestSignatures = ({
  setOpenDrawerConfirmConfigureSignature,
  users,
  setStepDrawer,
}: DrawerConfirmRequestSignaturesProps) => {
  return (
    <Box>
      <Box width="480px" padding="20px">
        <Header>
          <CloseRounded
            sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
            onClick={() => setOpenDrawerConfirmConfigureSignature(false)}
          />
          <span className="title">Assinatura</span>
        </Header>
        {users && users?.length > 0 ? (
          <Box>
            <Title mt="20px">Quem receberá a mensagem</Title>
            <Box width="100%" mt="20px" mb="20px">
              {users?.map(c => (
                <Tooltip title={c.email}>
                  <CardUsers>
                    <Box display="flex" alignItems="center" gap="10px">
                      {c?.avatar_url ? (
                        <Avatar sx={{ width: '40px' }}>
                          <img
                            src={c?.avatar_url as string}
                            alt="Foto de perfil"
                            style={{ width: '100%' }}
                          />
                        </Avatar>
                      ) : (
                        <Avatar
                          {...stringAvatar(c.name!)}
                          sx={{ width: '40px' }}
                        />
                      )}
                      <span className="name">{c.name}</span>
                    </Box>
                  </CardUsers>
                </Tooltip>
              ))}
            </Box>

            <TextField
              multiline
              rows={5}
              fullWidth
              placeholder="Digite a mensagem..."
            />
          </Box>
        ) : (
          <Box mt="20px"> Nenhum participante selecionado para assinatura.</Box>
        )}
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: users?.length > 0 ? 'end' : 'start',
          }}
        >
          <Button
            variant={users?.length > 0 ? 'contained' : 'outlined'}
            color={users?.length > 0 ? 'success' : 'primary'}
            sx={{
              marginTop: '30px',
              color: users?.length > 0 ? '#ffffff' : '#206da7',
              position: 'fixed',
              bottom: '20px',
            }}
            onClick={() =>
              setStepDrawer(users?.length > 0 ? 'success' : 'request')
            }
          >
            {users?.length > 0 ? 'Enviar mensagem' : 'Voltar'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
